//import { TAGS_DEFAULT_END, TAGS_DEFAULT_START } from "../conf/mtma-tags";

export class MtmaTag {
    Description: string;
    Code: string;
    ObjId: string;
    Actions: number[];
    RuleId: number;
    DtFrom: string;
    DtTo: string;
    RuleName: string;
    constructor() {
        //this.DtFrom = TAGS_DEFAULT_START;
        //this.DtTo = TAGS_DEFAULT_END;
        this.Actions = [255, 255];
    }
}
